interface IResultadoValidacaoAbas {
  valido: boolean;
  mensagem: string;
}

/**
 * Valida se a planilha Excel possui apenas uma aba antes da importação.
 */
function validarAbasPlanilha(sheetNames: string[]): IResultadoValidacaoAbas {
  if (sheetNames.length <= 1) {
    return { valido: true, mensagem: "" };
  }

  const nomesAbas = sheetNames.join(", ");
  const primeiraAba = sheetNames[0];

  return {
    valido: false,
    mensagem:
      `A planilha possui ${sheetNames.length} abas (${nomesAbas}). ` +
      `Exclua abas vazias (ex.: Planilha1) no Excel e envie novamente. ` +
      `Será usada apenas a primeira aba: "${primeiraAba}".`,
  };
}

export type { IResultadoValidacaoAbas };
export { validarAbasPlanilha };
